import PropTypes from "prop-types";
import { Switch as MuiSwitch, styled } from "@mui/material";

const Switch = styled(MuiSwitch)(({ theme }) => ({
  width: 36,
  height: 20,
  padding: 0,
  display: "flex",
  overflow: "visible",
  "&:active": {
    "& .MuiSwitch-thumb": {
      width: 18
    },
    "& .MuiSwitch-switchBase.Mui-checked": {
      transform: "translateX(12px)"
    }
  },
  "& .MuiSwitch-switchBase": {
    padding: 2,
    "&.Mui-checked": {
      transform: "translateX(16px)",
      color: theme.palette.common.white,
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: theme.palette.secondary.main,
        ...theme.applyStyles("dark", {
          backgroundColor: theme.palette.secondary.dark
        })
      }
    },
    "&.Mui-focusVisible": {
      "& .MuiSwitch-thumb": {
        boxShadow: `0 0 0 6px ${theme.palette.secondary.main}33`,
        transition: theme.transitions.create(["box-shadow"], {
          duration: 200,
          easing: "ease-out"
        })
      }
    }
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
    width: 16,
    height: 16,
    borderRadius: 8,
    transition: theme.transitions.create(["width", "box-shadow"], {
      duration: 300,
      easing: "ease-in-out"
    })
  },
  "& .MuiSwitch-track": {
    borderRadius: 20 / 2,
    opacity: 1,
    backgroundColor: theme.palette.grey[500],
    boxSizing: "border-box",
    ...theme.applyStyles("dark", {
      backgroundColor: "rgba(255,255,255,.35)"
    })
  }
}));

Switch.propTypes = {
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  value: PropTypes.any,
  name: PropTypes.string,
  inputProps: PropTypes.object,
  size: PropTypes.oneOf(["small", "medium"]),
  color: PropTypes.oneOf(["default", "primary", "secondary", "error", "info", "success", "warning"])
};

export default Switch;
